import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { hide, hideAll } from '@shared/easyfy.utils';
import formService from '@inlineServices/form.service';
import easyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';

namespace Easyfy.Modules {
  @invoke
  class Form {
    constructor() {

    }

    onInit() {
      globalEvent({
        type: 'submit',
        event: {
          action: 'ajax-form',
          callback: Form.onPostForm
        }
      });

      globalEvent({
        type: 'submit',
        event: {
          action: 'pre-post',
          callback: Form.onPrePostAction
        }
      });
    }

    static onPostForm = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const element: HTMLFormElement = e.target as HTMLFormElement;
      const data: FormData = new FormData(element);
      const dataUpdate = 'data-update';
      const dataHiddenValue = 'data-hidden-value';
      const datamessageContainer = element.attributes['data-message']?.value;
      const messageContainer = element.querySelector(`[data-container="${datamessageContainer}"]`) as HTMLElement;

      formService.PostForm(element.attributes['action']?.value, data).then(response => {
        if (messageContainer) {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message, messageContainer);
        } else {
          easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message);
        }

        if (response.data.success) {
          if (response.data.partial) {
            const updateContainer = element.attributes[dataUpdate]?.value;
            const container = document.querySelector(`[data-container="${updateContainer}"]`);

            if (container) {
              container.innerHTML = response.data.partial;

              // clear field for next form load
              const hiddenValue = element.querySelector<HTMLInputElement>(`[${dataHiddenValue}]`)?.value;
              if (hiddenValue) {
                element.setAttribute(dataUpdate, element.attributes[dataUpdate].value.replace(`-${hiddenValue}`, ''));
              }
            }

            const extraToggleEvent = element.attributes['data-extra-toggle-event']?.value;
            if (extraToggleEvent) {
              const container = document.querySelector(`[data-container="${extraToggleEvent}"]`);
              if (container) hide(container);

              const overlayElement: NodeListOf<HTMLElement> = document.querySelectorAll('[data-overlay-container]');
              hideAll(overlayElement);
            }
          } else if (response.data.reload) {
            setTimeout(function () {
              location.reload();
            }, 700);
          }
        }
      });

      return false;
    }

    static onPrePostAction = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const form: HTMLFormElement = e.target as HTMLFormElement;
      const data: FormData = new FormData(form);
      const datamessageContainer = form.attributes['data-message']?.value;
      const messageContainer = form.querySelector(`[data-container="${datamessageContainer}"]`) as HTMLElement;
      const validationMethod = form.attributes['data-validate-method']?.value;

      if (!validationMethod) return;

      formService.PostForm(validationMethod, data).then(response => {
        if (response.data.success) {
          form.submit();
        }
        else {
          if (messageContainer) {
            easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message, messageContainer);
          } else {
            easyfyToaster.toaster(response.data.success ? MessageSeverity.success : MessageSeverity.error, response.data.message);
          }
        }
      });

      return false;
    }
  }
}